import React, { Component } from 'react';
import './DashboardPayables.css';
import CountAndProgress from './../../../Components/CountAndProgress/CountAndProgress';
import { restRequest } from '../../../Helpers/RequestHelper';
import { Link } from 'react-router-dom';
import Loader from '../../../Components/Loader/Loader';
import AccessDenied from '../../../Components/AccessDenied/AccessDenied';
import DataError from '../../../Components/DashboardDataError/DB_DataError';
import { checkError } from '../../../Helpers/AuthHelper';
import { setDashboardAmount } from '../../../Helpers/setAmount';
import { withTranslation } from 'react-i18next';
import { getObjFromLS } from '../../../Helpers';
class DashboardPayables extends Component {
  constructor(props) {
    super();
    this.state = {
      data: {},
      loading: true,
      accessDenied: false,
      accessError: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }
  //   shouldComponentUpdate(nextProps) {
  //     return (this.props !== nextProps) ? false : true;
  // }
  // fetchData(currentDateRange) {
  dashboard_preferences = JSON.parse(
    localStorage.getItem('dashboardPreferences')
  );
  permissions = getObjFromLS('role').permissions;

  fetchData(
    currentDateRange = this.dashboard_preferences.payable,
    startData,
    endDate
  ) {
    this.setState({ loading: true });
    const hasPermission = this.permissions?.DashboardPayableView;
    let superAccess = this.permissions?.superAccess;
    if (!superAccess && !hasPermission) {
      this.setState({ accessDenied: true, loading: false });
      return;
    }

    restRequest(
      'get',
      `dashboard/pay_ables/${currentDateRange === 'custom'
        ? `custom?starting_date=${startData}&ending_date=${endDate}` //this part is for custom datepicker range
        : currentDateRange
          ? currentDateRange
          : this.props.currentDateRange
      }`
    )
      .then((res) => {
        this.setState({ data: res, loading: false });
        this.props.setPayable(
          `${res.currency ? res.currency : '$'}${setDashboardAmount(
            res.pay_ables
          )}`
        );
      })
      .catch((err) => {
        checkError(err);
        if (err.response.status === 403) {
          this.setState({ accessDenied: true, loading: false });
        } else {
          this.setState({ accessError: true, loading: false });
        }
      });
  }

  // componentWillReceiveProps(nextProps) {
  //   this.fetchData(nextProps.currentDateRange)
  // }
  componentWillReceiveProps(nextProps) {
    // nextProps.currentDateRange !== this.props.currentDateRange &&  this.fetchData(nextProps.currentDateRange)
    (nextProps.currentDateRange !== this.props.currentDateRange ||
      nextProps.startData !== this.props.startData ||
      nextProps.endDate !== this.props.endDate) &&
      this.fetchData(
        nextProps.currentDateRange.payable,
        nextProps.startData,
        nextProps.endDate
      );
  }
  render() {
    const { t } = this.props;
    if (this.state.loading) return <Loader />;
    if (this.state.accessDenied)
      return <AccessDenied className="small dashboard " type="Bills" />;
    if (this.state.accessError)
      return <DataError className="small dashboard " type="Bills" />;
    const { data } = this.state;
    const { due, over_due } = data;
    return (
      <div className="dashboard_payables">
        {/*<Link className="dashboard_receivables_child"  to="bills?filter=partially paid&sort=created_at&page=1&orderBy=desc&view=20">*/}
        <Link
          className="dashboard_receivables_child"
          to={`bills?filter=due&sort=created_at&page=1&orderBy=desc&view=20&start=${data.start_date}&end=${data.end_date}`}
        >
          <CountAndProgress
            title={t('Dashboard.receiv_ables.bills')}
            dueFlag
            color="#306AB4"
            className="payable"
            amount={setDashboardAmount(due.amount)}
            currency={data.currency}
            percentage={due.percent}
            count={due.bills}
          />
        </Link>
        {/*<Link className="dashboard_receivables_child" to="bills?filter=overdue&sort=created_at&page=1&orderBy=desc&view=20">*/}
        <Link
          className="dashboard_receivables_child"
          to={`bills?filter=overdue&sort=created_at&page=1&orderBy=desc&view=20&start=${data.start_date}&end=${data.end_date}`}
        >
          <CountAndProgress
            title={t('Dashboard.receiv_ables.bills')}
            color="#D42F2F"
            currency={data.currency}
            amount={setDashboardAmount(over_due.amount)}
            percentage={over_due.percent}
            count={over_due.bills}
          />
        </Link>
      </div>
    );
  }
}

export default withTranslation()(DashboardPayables);
